module.exports = {"title":"Интервью экспертов и&nbsp;другие материалы"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/articles-list.ru.json
// module id = 141
// module chunks = 0